export const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isAppInitialized: false,
  verifyCode: null,
};
